<template>
  <div class="container-failure">
    <van-dialog v-model="showDia" :showConfirmButton="false" closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <!-- <div class="tit" v-if="tit">{{ tit }}</div> -->
        <div class="con" v-if="con">{{ con }}</div>
        <div class="btn" @click="close">{{ $t('lang.gotit') }}</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showDia: {
      default: false,
    },
    // tit: {},
    con: {},
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    close() {
      this.$parent.closeDia()
    },
  },
  watch: {},
  computed: {},
}
</script>
<style lang="scss" scoped>
.container-failure {
  .dialog {
    width: 100%;
    padding: 30px 20px;
  }
  // .tit {
  //   width: 100%;
  //   font-size: 16px;
  //   font-family: Inter;
  //   font-weight: 600;
  //   color: #333333;
  //   line-height: 26px;
  //   text-align: center;
  // }
  .con {
    width: 100%;
    margin: 0px 0 20px 0;
    font-size: 16px;
    font-family: Inter;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    text-align: center;
    overflow: hidden;
    white-space: pre-wrap;
    font-style: normal;
    > span {
      color: red;
    }
  }
  .btn {
    width: 200px;
    padding: 10px 0px;
    // height: 40px;
    margin: 0 auto;
    // line-height: 40px;
    white-space: wrap;
    text-align: center;
    background: #a338fc;
    border-radius: 20px;
    font-size: 16px;
    font-family: Inter;
    font-weight: 600;
    color: #ffffff;
  }
}
</style>
